import { render, staticRenderFns } from "./GireseManual.vue?vue&type=template&id=0a24b1b5&scoped=true&"
import script from "./GireseManual.vue?vue&type=script&lang=js&"
export * from "./GireseManual.vue?vue&type=script&lang=js&"
import style0 from "./GireseManual.vue?vue&type=style&index=0&id=0a24b1b5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a24b1b5",
  null
  
)

export default component.exports